import DominioBusiness from "@/business/protocolo/DominioBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import Http from "@/commons/Http";
import FrontBusiness from "@/business/FrontBusiness";
import Utils from "@/commons/Utils";
import CloudStorageBusinessFacede from "@/business/cloudStorage/CloudStorageBusinessFacede";
import AnexoFactory from "@/business/cloudStorage/AnexoFactory";

const path = 'api/anexo';

export default {

  async getDetalhesById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/detalhes/${id}`);
  },

  async ordenar(ordens){
    return Http.post(`${path}/ordenar`, ordens);
  },

  async deleteById(id){
    return Http.delete(`${path}/${id}`);
  },

  async save(id, dto){
    return Http.post(`${path}/${id}`, dto);
  },

  async listar(entidade, id = '', grupo = '', resetCache = ''){
    if(id && !Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${entidade}/${id}${grupo ? '/' + grupo : ''}${resetCache ? '?reset=' + resetCache : ''}`);
  },


  async count(entidade, id = '', grupo = '', resetCache = ''){
    if(id && !Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/count/${entidade}/${id}${grupo ? '/' + grupo : ''}${resetCache ? '?reset=' + resetCache : ''}`);
  },


  async countDocumentosDiligencias(id){
    if(!id || (id && !Utils.testUUID(id))){
      return Promise.reject();
    }
    return Http.get(`${path}/count/NOTIFICACAO_DILIGENCIA/${id}`);
  },

  async downloadPdfDigitalizacao(entidade, id = '', grupo = '', resetCache = ''){

    if(id && !Utils.testUUID(id)){
      return Promise.reject();
    }
    const config = {
      responseType: 'blob',
      timeout : 0,
      headers: {'Content-Type': 'application/json'}
    };

    return Http.get(`${path}/pdf/${entidade}/${id}${grupo ? '/' + grupo : ''}${resetCache ? '?reset=' + resetCache : ''}`, config);
  },

  urlPdfDigitalizacao(entidade, id = '', grupo = '', resetCache = ''){
    if(id && !Utils.testUUID(id)){
      return Promise.reject();
    }
    return `${window.server.API}/api/v2/anexo/pdf/${entidade}/${id}${grupo ? '/' + grupo : ''}${resetCache ? '?reset=' + resetCache : ' '}`;
  },

  async agendarPdfDigitalizacao(entidade, id = '', grupo = '') {
    if (id && !Utils.testUUID(id)) {
      return Promise.reject();
    }
    return Http.post(`api/v2/anexo/pdf/agendar/${entidade}/${id}${grupo ? '/' + grupo : ''}`);
  },

  async listarAuditoria(entidade, id = '', grupo = ''){
    if(id && !Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/auditoria/${entidade}/${id}${grupo ? '/' + grupo : ''}`);
  },

  async inserir(file, entidade, id = '', progress = null, checklist = false, grupo = null, etapa = ''){

    //Tamanho máximo em Bytes
    const tamanhoMaxArquivo = FrontBusiness.maxUploadSize;
    // console.debug(file.size, tamanhoMaxArquivo, file.size<=tamanhoMaxArquivo);

    if (file.size <= tamanhoMaxArquivo) {
      const business = await CloudStorageBusinessFacede.getStorageBusiness();
      const anexo = AnexoFactory.criarAnexo(file, entidade, id, checklist, grupo, etapa);
      return business.upload(file, anexo);
    } else {
      FrontBusiness.showError('', 'O arquivo excede o tamanho máximo de ' + Utils.humanFileSize(tamanhoMaxArquivo, false)+ ' permitido');
    }

  },

  async ver(anexoOrIdAnexo = {}, thumb = false, resetCache = ''){
    let anexo = anexoOrIdAnexo?.id ? anexoOrIdAnexo : null;
    if((!Utils.isEmptyNullOrUndefined(anexo) && !Utils.testUUID(anexo.id) || (Utils.isEmptyNullOrUndefined(anexo) && !Utils.testUUID(anexoOrIdAnexo)))){
      return '-';
    } else if (Utils.isEmptyNullOrUndefined(anexo)) {
      const responseAnexo = await this.getDetalhesById(anexoOrIdAnexo);
      if (responseAnexo?.data) {
        anexo = responseAnexo.data;
      } else {
        return '-';
      }
    }
    const business = await CloudStorageBusinessFacede.getStorageBusiness();
    if(thumb){
      return await business.ver(anexo, thumb, resetCache);
    }else{
      return await business.verDigitalizacao(anexo, thumb, resetCache);
    }
  },

  async download(anexo, assinado = false, callBack = () => {}){
    const business = await CloudStorageBusinessFacede.getStorageBusiness();
    return business.download(anexo, assinado, callBack);
  },

  async getUploadUrl(anexo, id = '', grupo = null, etapa = null){
    const business = await CloudStorageBusinessFacede.getStorageBusiness();
    return business.getUploadUrl(anexo, id, grupo, etapa);
  },

  async salvarAnexo(anexo){
    return Http.post(`${path}/`, anexo);
  },

  async salvarTags(anexoId, dto){
    return Http.post(`${path}/tags/${anexoId}`, dto);
  },

  getEntidades(){

    let entidades = [];

    DominioBusiness.dominiosAtivos().forEach(e => {
      DominioBusiness.getTiposProtocoloPorDominio(e.id).forEach(t => {
        entidades.push({id : e.id + '-' + t.id, nome : FrontBusiness.nomearProtocolo(e.id, t.id), entidade: 'PROTOCOLO', dominio: e.id, tipoProtocolo: t.id, permissaoGerenciamento: this.getPermissaoGerenciamentoDigitalizacao(e.id, t.id)});
      });
    });

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RI')){
        entidades.push(
          {id : 'PRE_MATRICULA', nome : 'Pré-Matrícula', entidade: 'INDICADOR_REAL', livro: 'MATRICULA', dominio: 'PROTOCOLO_RI', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_MATRICULA'},
          {id : 'INDICADOR_REAL', nome : 'Matrícula', entidade: 'INDICADOR_REAL', livro: 'MATRICULA', dominio: 'PROTOCOLO_RI', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_MATRICULA'},
          {id : 'TRANSCRICAO', nome : 'Transcrição', entidade: 'INDICADOR_REAL', livro: 'TRANSCRICAO', dominio: 'PROTOCOLO_RI', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_TRANSCRICAO'},
          {id : 'REGISTRO_AUXILIAR', nome : 'Registro Auxiliar', entidade: 'REGISTRO_AUXILIAR', livro: 'REGISTRO_AUXILIAR', dominio: 'PROTOCOLO_RI', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_REGISTRO_AUXILIAR'},
        )
    }

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RTD')){
      entidades.push(
        {id : 'REGISTRO_TD', nome : 'Registro TD', entidade: 'INDICADOR', livro : 'REGISTRO_TD', dominio: 'PROTOCOLO_RTD', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_REGISTRO_RTD'},
      )
    }

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RCPJ')){
      entidades.push(
        {id : 'REGISTRO_PJ', nome : 'Registro PJ', entidade: 'INDICADOR', livro : 'REGISTRO_PJ', dominio: 'PROTOCOLO_RCPJ', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_REGISTRO_RCPJ'},
      )
    }

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RI')){
      entidades.push(
        {id: 'EXIGENCIA_RI', nome: 'Exigência RI', entidade: 'EXIGENCIA', dominio: 'RI', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXIGENCIA_RI'}
      );
    }
    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RTD')){
      entidades.push(
        {id: 'EXIGENCIA_RTD', nome: 'Exigência RTD', entidade: 'EXIGENCIA', dominio: 'RTD', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXIGENCIA_RTD'}
      );
    }
    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RCPJ')){
      entidades.push(
        {id: 'EXIGENCIA_RCPJ', nome: 'Exigência RCPJ', entidade: 'EXIGENCIA', dominio: 'RCPJ', permissaoGerenciamento: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXIGENCIA_RCPJ'}
      );
    }

    entidades.push(
      {id : 'OCORRENCIA', nome : 'Ocorrência', entidade : 'OCORRENCIA', dominio : 'OCORRENCIA'},
      {id : 'NOTIFICACAO', nome : 'Notificação', entidade: 'NOTIFICACAO', dominio: 'NOTIFICACAO'},
      {id : 'OFICIO', nome : 'Ofício', entidade: 'OFICIO', dominio: 'OFICIO'},
      {id : 'DOCUMENTACAO', nome : 'Documentação', entidade: 'DOCUMENTACAO', dominio: ''}
    )
    return entidades;

  },

  // COD-5822: mapeia cada entidade de protocolo/certidão das categorias RI, RTD e RCPJ
  // para a permissão específica de gerenciamento de digitalização do respectivo domínio.
  getPermissaoGerenciamentoDigitalizacao(dominio, tipoProtocolo){
    const mapa = {
      'PROTOCOLO_RI':   { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_PROTOCOLO_RI', EXAME_CALCULO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXAME_CALCULO_RI', PROCESSO_INTERNO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_PROCESSO_INTERNO', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_PROTOCOLO_RI' },
      'CERTIDAO_RI':    { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_CERTIDAO_RI', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_CERTIDAO_RI' },
      'PROTOCOLO_RTD':  { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_PROTOCOLO_RTD', EXAME_CALCULO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXAME_CALCULO_RTD', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_PROTOCOLO_RTD' },
      'CERTIDAO_RTD':   { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_CERTIDAO_RTD', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_CERTIDAO_RTD' },
      'PROTOCOLO_RCPJ': { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_PROTOCOLO_RCPJ', EXAME_CALCULO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_EXAME_CALCULO_RCPJ', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_PROTOCOLO_RCPJ' },
      'CERTIDAO_RCPJ':  { NORMAL: 'PERMITIR_GERENCIAR_DIGITALIZACAO_CERTIDAO_RCPJ', ORCAMENTO: 'PERMITIR_GERENCIAR_DIGITALIZACAO_ORCAMENTO_CERTIDAO_RCPJ' },
    };
    return mapa[dominio]?.[tipoProtocolo] || null;
  },

  getEntidadesDocumentosArquivados (){

    let origens = []

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RI')){
      origens.push(
        {id : 'INDICADOR_REAL', nome : 'Matrícula'},
        {id : 'TRANSCRICAO', nome : 'Transcrição'},
        {id : 'REGISTRO_AUXILIAR', nome : 'Registro Auxiliar'},
        {id : 'PROTOCOLO_RI-NORMAL', nome : 'Protocolo RI'},
        {id : 'PROTOCOLO_RI-EXAME_CALCULO', nome : 'Exame e Cálculo RI'},
        {id : 'PROTOCOLO_RI-PROCESSO_INTERNO', nome : 'Processo Interno RI'},
        {id : 'PROTOCOLO_RI-ORCAMENTO', nome : 'Orçamento de Protocolo RI'},
        {id : 'CERTIDAO_RI-NORMAL', nome : 'Certidão RI'},
        {id : 'CERTIDAO_RI-ORCAMENTO', nome : 'Orçamento de Certidão RI'},
      )
    }

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RTD')){
      origens.push(
        {id : 'REGISTRO_TD', nome : 'Registro TD'},
        {id : 'PROTOCOLO_RTD-NORMAL', nome : 'Protocolo RTD'},
        {id : 'PROTOCOLO_RTD-ORCAMENTO', nome : 'Orçamento de Protocolo RTD'},
        {id : 'CERTIDAO_RTD-NORMAL', nome : 'Certidão RTD'},
        {id : 'CERTIDAO_RTD-ORCAMENTO', nome : 'Orçamento de Certidão RTD'},
      )
    }

    if(VueBusiness.getVueRoot()?.atribuicaoAtiva('RCPJ')){
      origens.push(
        {id : 'REGISTRO_PJ', nome : 'Registro PJ'},
        {id : 'PROTOCOLO_RCPJ-NORMAL', nome : 'Protocolo RCPJ'},
        {id : 'PROTOCOLO_RCPJ-ORCAMENTO', nome : 'Orçamento de Protocolo RCPJ'},
        {id : 'CERTIDAO_RCPJ-NORMAL', nome : 'Certidão RCPJ'},
        {id : 'CERTIDAO_RCPJ-ORCAMENTO', nome : 'Orçamento de Certidão RCPJ'},
      )
    }

    origens.push(
      {id : 'OCORRENCIA', nome : 'Ocorrência'},
      {id : 'NOTIFICACAO', nome : 'Notificação'},
      {id : 'OFICIO', nome : 'Ofício'},
      {id : 'INDICADOR_PESSOAL', nome : 'Indicador Pessoal'},
    )

    return origens;
  },

  // grupo e etapa entram na assinatura do upload, então precisam ser informados aqui exatamente como
  // vão para a janela do scanner — o backend confere a tupla inteira no POST.
  async createHash(entidade, id = '', grupo = null, etapa = null){
    let query = `client=${encodeURIComponent(window.server.API)}`;
    if(grupo) query += `&grupo=${encodeURIComponent(grupo)}`;
    if(etapa) query += `&etapa=${encodeURIComponent(etapa)}`;
    return Http.get(`api/digitalizacao/hash/${entidade}${id ? `/${id}` : ''}?${query}`);
  },

  async getProximoRegistro(livro, id, acao){
    return Http.get(`api/digitalizacao/${livro}/${id}/${acao}`);
  },

  async gerarDigitalizacaoAtoDigital(form){
    return Http.post(`api/digitalizacao/gerar-digitalizacao-ato-digital`,form);
  },

  async gerarDigitalizacaoAtoDigitalProtocolo(form){
    return Http.post(`api/digitalizacao/gerar-digitalizacao-ato-digital-protocolo`,form);
  },

  async listarIndicadoresAtosDigitaisProtocolo(form){
    return Http.post(`api/digitalizacao/listar-indicadores-atos-digitais-protocolo`,form);
  },

  tiposDigitalizacao() {
    return [
      { id: '', nome: 'Todos' },
      { id: 'ATUALIZADA', nome: 'Atualizada' },
      { id: 'DESATUALIZADA', nome: 'Desatualizada' }
    ];
  },

  async getDetalhesAssinaturaById(id){
    return Http.get(`${path}/detalhes/${id}/assinatura`);
  },

  async listarGerenciamento(filtros = {}) {
    const params = new URLSearchParams(filtros).toString();
    return Http.get(`api/anexo/gerenciamento/${params ? '?' + params : ''}`);
  },

  async moverParaLixeira(ids) {
    return Http.post('api/anexo/gerenciamento/mover-para-lixeira', ids);
  },

  async restaurarDaLixeira(ids) {
    return Http.post('api/anexo/gerenciamento/restaurar-da-lixeira', ids);
  },

  async listarLixeira(filtros = {}) {
    const params = new URLSearchParams(filtros).toString();
    return Http.get(`api/anexo/gerenciamento/lixeira${params ? '?' + params : ''}`);
  },

  async limparLixeira(ids = [], expiradosApenas = false) {
    return Http.post('api/anexo/gerenciamento/limpar-lixeira', { ids, expiradosApenas });
  },

  async listarAuditoriaGerenciamento(filtros = {}) {
    const params = new URLSearchParams(filtros).toString();
    return Http.get(`api/anexo/gerenciamento/auditoria${params ? '?' + params : ''}`);
  },

  async getPendentesBucket() {
    return Http.get('api/anexo/gerenciamento/pendentes-bucket');
  },

  async excluirDoBucket(ids) {
    return Http.post('api/anexo/gerenciamento/excluir-bucket', ids);
  },

  async listarLegado(filtros = {}) {
    const params = new URLSearchParams(filtros).toString();
    return Http.get(`api/anexo/gerenciamento/legado${params ? '?' + params : ''}`);
  },

  downloadLegado(path) {
    return `${window.server.API}/api/anexo/gerenciamento/legado/download?path=${encodeURIComponent(path)}`;
  },

  // arquivos: [{caminho, tamanho}] — vai para a lixeira, nada é removido do bucket aqui
  async moverLegadoParaLixeira(arquivos) {
    return Http.post('api/anexo/gerenciamento/legado/mover-para-lixeira', arquivos);
  },

  async restaurarLegadoDaLixeira(ids) {
    return Http.post('api/anexo/gerenciamento/legado/restaurar-da-lixeira', ids);
  },

  async excluirLegadoDaLixeira(ids) {
    return Http.post('api/anexo/gerenciamento/legado/excluir-da-lixeira', ids);
  },

  async downloadZip(ids) {
    const config = { responseType: 'blob' };
    return Http.post('api/anexo/gerenciamento/download-zip', ids, config);
  },

  async downloadLegadoZip(paths) {
    const config = { responseType: 'blob' };
    return Http.post('api/anexo/gerenciamento/legado/download-zip', paths, config);
  },

  async copiarAnexos(selecionados,destinos){
    let body={
      idsAnexos:selecionados,
      destinos:destinos
    }
    return Http.post(`${path}/copiar-anexos`,body)
  },

  async fileToBase64(file) {
    if (!file) return null;

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = err => reject(err);
      reader.readAsDataURL(file);
    });
  },

}
